import classes from "./bullet.module.scss";
import { AnimatePresence, motion } from "framer-motion";
import { useSelector } from "react-redux";
import { SCREENS } from "@educaplay/store/constants";

export default function Bullet(props) {
  const { open, text } = props;
  const view = useSelector((state) => state.game.view);

  return (
    <AnimatePresence>
      {open && view === SCREENS.GAME && (
        <motion.div
          className={classes.msgcontainer}
          initial={{ y: "-200%" }}
          animate={{ y: 0 }}
          exit={{ y: "-300%" }}
          transition={{ duration: 0.3, type: "spring", stiffness: 300 }}
        >
          <div className={classes.msgpill}>{text}</div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
